import { StylesConfig } from 'react-select';

/**
 * Shared gray select styles for react-select components.
 * Replaces the default blue active/focus colors with gray to match the menu button styling.
 */
export const graySelectStyles: StylesConfig<any, false> = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? 'rgb(209, 213, 219)'     // gray-300
      : state.isFocused
      ? 'rgb(243, 244, 246)'     // gray-100
      : 'white',
    color: '#000',
    ':hover': {
      backgroundColor: 'rgb(229, 231, 235)', // gray-200
    },
    ':active': {
      backgroundColor: 'rgb(229, 231, 235)', // gray-200
    },
  }),
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? 'transparent' : 'rgb(209, 213, 219)', // gray-300
    boxShadow: state.isFocused ? '0 0 0 2px #00b142' : provided.boxShadow, // ptsblue-normal
    '&:hover': {
      borderColor: state.isFocused ? 'transparent' : 'rgb(209, 213, 219)', // gray-300
    },
  }),
};

export const graySelectMultiStyles: StylesConfig<any, true> = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? 'rgb(209, 213, 219)'     // gray-300
      : state.isFocused
      ? 'rgb(243, 244, 246)'     // gray-100
      : 'white',
    color: '#000',
    ':hover': {
      backgroundColor: 'rgb(229, 231, 235)', // gray-200
    },
    ':active': {
      backgroundColor: 'rgb(229, 231, 235)', // gray-200
    },
  }),
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? 'transparent' : 'rgb(209, 213, 219)', // gray-300
    boxShadow: state.isFocused ? '0 0 0 2px #00b142' : provided.boxShadow, // ptsblue-normal
    '&:hover': {
      borderColor: state.isFocused ? 'transparent' : 'rgb(209, 213, 219)', // gray-300
    },
  }),
};
